import { TForcePathsFromRoutes } from '../ads';

export const getForcePathsFromRoutes: TForcePathsFromRoutes = (routes: Record<string, string>) => {
  return [
    {
      siteRoute: {
        path: routes.CharacterDetails,
        exact: true,
        strict: true
      },
      forcePath: 'character-page'
    },

    // '/',
    // routes.CharacterDetails,
    // routes.GuildDetails,
    // routes.MythicKeystoneRun

    ...[
      routes.BlizzardTournaments,
      routes.CommunityEvents,
      routes.EventRegister,
      routes.EventTeams,
      routes.EventBrackets,
      routes.EventBracketsTimeTrialsDungeons,
      routes.EventBracketsTimeTrialsTeams,
      routes.EventBracketsPlunderstormRoyale,
      routes.EventSection,
      routes.EventTeamDetails
    ].map((path) => ({
      siteRoute: {
        path
      },
      forcePath: 'blizzard'
    }))
  ];
};
